
// import { $ac } from '@helpers'

import { /* getCurrentInstance, ref,  */defineAsyncComponent } from "@vue/runtime-core";

const asyncComponents = {
    install(app/* , options */) {
// log('in asyncComponents', app/* , options */)

        //? in Components directory
        var c_comp = [
            'HeaderApp','HeaderAuth','HeaderUserMenu',
            // 'Flash',
        ]
        _.each(c_comp, v=>{
            app.component(v, defineAsyncComponent(()=>import(`./Components/${v}.vue`)))
        })


        //? in Components/partials directory
        var c_comp_partials = [
            'Titles','MyHead','Popup','OpenInNewTab',
            'MyAlert','MyDialog','MySelect','MyExpansion','MyInertiaLink','DrawerActions',
            'CopyAllColisRefs',
            //,'AlertInLayout', 'MyGuidedTour'
        ]
        _.each(c_comp_partials, v=>{
            app.component(v, defineAsyncComponent(()=>import(`./Components/partials/${v}.vue`)))
        })


        //? in Components/inputs directory
        var c_comp_inputs = [
            'TextEditor', 'MyPopupEdit',
        ]
        _.each(c_comp_inputs, v=>{
            app.component(v, defineAsyncComponent(()=>import(`./Components/inputs/${v}.vue`)))
        })
    }
}
export default asyncComponents
